import type { IconData } from '@stacksjs/iconify-core'

export const brightness: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 18q.168 0 0-16a8 8 0 1 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default brightness
